import isEqual from 'lodash/isEqual';
import { useAppSelector } from '../store';
import requireMetadata from './requireMetadata';

export default function useRequiredMetadata() {
  return useAppSelector(requireMetadata, isEqual);
}
